module.exports = __webpack_public_path__ + "assets/browserProfilesIcon.ec98f320.svg";